import type { Theme } from '@emotion/react'

export type DistributionColors = {
  savings: string
  investing: string
  bitcoin: string
  cashBalance: string
}

export const DISTRIBUTION_COLORS_LIGHT = {
  savings: '#00D64F',
  investing: '#9013FE',
  bitcoin: '#00D4FF',
  cashBalance: '#333333',
}

export const DISTRIBUTION_COLORS_DARK = {
  savings: '#00D64F',
  investing: '#9013FE',
  bitcoin: '#00D4FF',
  cashBalance: '#FFFFFF',
}

// Native reserves the first shade for Cash balance and assigns the remaining
// shades in distribution order (largest share first, then destination rank).
export const getUnifiedDistributionColors = (
  distributions: { id: string; percentage: number }[],
  dataColors: Theme['arcadeColors']['data']
): DistributionColors => {
  const greenPalettes = [
    [dataColors.partOfOneOne],
    [dataColors.partOfTwoOne, dataColors.partOfTwoTwo],
    [dataColors.partOfThreeOne, dataColors.partOfThreeTwo, dataColors.partOfThreeThree],
    [dataColors.partOfFourOne, dataColors.partOfFourTwo, dataColors.partOfFourThree, dataColors.partOfFourFour],
  ]
  const destinationOrder = ['savings', 'bitcoin', 'investing']
  const ranked = destinationOrder
    .filter(id => distributions.some(distribution => distribution.id === id))
    .map(id => ({
      id,
      percentage: distributions
        .filter(distribution => distribution.id === id)
        .reduce((total, distribution) => total + distribution.percentage, 0),
    }))
    .sort((a, b) => b.percentage - a.percentage || destinationOrder.indexOf(a.id) - destinationOrder.indexOf(b.id))
  const palette = greenPalettes[Math.min(ranked.length, 3)]
  const colors: DistributionColors = {
    cashBalance: palette[0],
    savings: dataColors.partOfFourTwo,
    bitcoin: dataColors.partOfFourThree,
    investing: dataColors.partOfFourFour,
  }
  ranked.forEach(({ id }, index) => {
    colors[id as keyof DistributionColors] = palette[index + 1]
  })
  return colors
}
